export default class DecryptageArticle {
  constructor({
    title,
    thumbnail,
    link,
    category,
    sub_category: subCategory,
    category_id: categoryId,
    sub_category_id: subCategoryId,
    chapo,
  }) {
    this.title = title;
    this.thumbnail = thumbnail;
    this.link = link;
    this.category = category;
    this.subCategory = subCategory;
    this.categoryId = categoryId;
    this.subCategoryId = subCategoryId;
    this.chapo = chapo;
  }

  getTitle() {
    return this.title;
  }

  getThumbnail() {
    return this.thumbnail;
  }

  getLink() {
    return this.link;
  }

  getCategory() {
    return this.category;
  }

  getSubCategory() {
    return this.subCategory;
  }

  getCategoryId() {
    return this.categoryId;
  }

  getSubCategoryId() {
    return this.subCategoryId;
  }

  getChapo() {
    return this.chapo;
  }
}
